var exports = {
  "ec": "SelectionsTab.module__descriptionSmall___dEtuSj",
  "Uz": "SelectionsTab.module__gridDouble___dEtuSj",
  "hK": "SelectionsTab.module__gridSingle___dEtuSj",
  "Wh": "SelectionsTab.module__contentList___dEtuSj",
  "Ib": "SelectionsTab.module__sliderRow___dEtuSj",
  "xJ": "SelectionsTab.module__sliderContainer___dEtuSj",
  "rv": "SelectionsTab.module__sliderValue___dEtuSj",
  "RE": "SelectionsTab.module__sliderValueDisabled___dEtuSj",
};

module.exports = exports;
